import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {buttonPrototype} from '../../commonComponents/buttonBar'
import DispatchBar from './dispatchBar'
import * as workorderActions from '../workorderActions'

function mapStateToProps(state, ownProps) {
    return {}
}
function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(workorderActions, dispatch),
    }
}
class JobDetailsBar extends React.Component {

    static defaultProps = {
        archived: true,
        onArchiveChanged: () => {},
        disabled: false, // for the entire bar, overrides other disabled states
        workorderId: 0,
        workorderGuid: '',
        releasedTime: null,
        ownerPartyId: null,
        selectedCompanyId: null,

    }

    changeArchiveStatus = async() => {
        this.props.setWorkorderArchived(this.props.workorderId, !this.props.archived)
            .then(() => this.props.onArchiveChanged())
    }

    render() {
        const machineViewDomain = window.location.hostname.includes('.ravenslingshot') ? `https://apps.ravenslingshot.com` : `https://apps.raven.engineering`
        const liveJobLink = `${machineViewDomain}/MachineView?liveJobGuid=${this.props.workorderGuid}`

        const notOwner = this.props.ownerPartyId === null ||
            this.props.selectedCompanyId === null ||
            this.props.ownerPartyId !== this.props.selectedCompanyId


        return (
            <DispatchBar name="JobDetailsBar"
                saved={true}
                jobReportAvailable={this.props.jobReportAvailable}
                disabled={this.props.disabled}
                archived={this.props.archived}
                releasedTime={this.props.releasedTime}
                notOwner={notOwner}
                frontChildren={[
                    buttonPrototype({
                        label: 'Live View',
                        iconPath: `jobCard/JobCard_LiveViewWhite`,
                        mobileIconPath: `jobCard/JobCard_LiveView`,
                        disabledIconPath: `jobCard/JobCard_LiveViewDisabled`,
                        href: liveJobLink,
                        visible: !this.props.archived,
                        disabled: !this.props.workorderGuid || notOwner,

                    }),
                ]}
                backChildren={[
                    buttonPrototype({
                        label: 'Archive',
                        onClick: this.changeArchiveStatus,
                        iconPath: `jobCard/JobCard_BtnArchiveJobWhite`,
                        mobileIconPath: `jobCard/JobCard_BtnArchiveJob`,
                        disabledIconPath: `jobCard/JobCard_BtnArchiveJobDisabled`,
                        visible: !this.props.archived,
                        disabled: !this.props.workorderGuid || notOwner,

                    }),
                    buttonPrototype({
                        label: 'Unarchive',
                        onClick: this.changeArchiveStatus,
                        iconPath: `jobCard/JobCard_BtnUnarchiveJobWhite`,
                        mobileIconPath: `jobCard/JobCard_BtnUnarchiveJob`,
                        disabledIconPath: `jobCard/JobCard_BtnUnarchiveJobDisabled`,
                        visible: this.props.archived,
                        disabled: !this.props.workorderGuid || notOwner,
                    }),
                ]}
                templateOverrides={{href: `/jobs/template/${this.props.workorderId}`, disabled: !this.props.workorderId || notOwner}}
            />
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(JobDetailsBar)
